import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const UserResearchAnalysis = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/uiux-1.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">User Research & Analysis: Understanding Your Audience for Success</h1>
                  <h2 id="sub_heading1">
                  In today's digital world, businesses and product teams must deeply understand their audience to create meaningful and effective experiences. This is where User Research & Analysis plays a crucial role. By gathering insights about user behavior, needs, and motivations, businesses can design better products, improve customer satisfaction, and drive business success.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              What is User <span>Research & Analysis ?</span>
              </h3>
                <p>User Research & Analysis is the process of studying and understanding users to create user-centered products and services. It involves qualitative and quantitative research methods to gather data about user needs, behaviors, pain points, and expectations.</p>
               
                <h3><span>Importance of User Research & Analysis</span></h3>
                <h4>1.	Enhances User Experience (UX): </h4>
                <p>Understanding users’ preferences leads to intuitive and engaging designs.</p>
                <h4>2.	Reduces Development Costs</h4>
                <p>Early insights help avoid costly design changes later.</p>
                <h4>3.	Increases Customer Satisfaction: </h4>
                <p>Products tailored to user needs result in higher satisfaction and loyalty.</p>
                <h4>4.	Informs Business Strategy: </h4>
                <p>Data-driven decisions improve product-market fit.</p>
                <h4>5.	Improves Conversion Rates: </h4>
                <p>Addressing user pain points leads to better engagement and increased conversions.</p>
                <h3><span>Types of User Research</span></h3>
                <ul>
                    <h4>1. Primary Research</h4>
                    <li>Direct interaction with users through interviews, surveys, usability testing, and observations.</li>
                    <h4>2. Secondary Research</h4>
                    <li>Analyzing existing data sources, competitor research, and industry reports.</li>
                    <h4>3. Qualitative Research</h4>
                    <li>Focuses on user emotions, behaviors, and motivations (e.g., open-ended interviews, focus groups).</li>
                    <h4>4. Quantitative Research</h4>
                    <li>Involves numerical data and statistics (e.g., surveys with large sample sizes, A/B testing).</li>
                </ul>
                <h3><span>Methods of User Research</span></h3>
                <h4>1.	Surveys & Questionnaires: </h4>
                <p>Structured questions to gather broad insights.</p>
                <h4>2.	Interviews:</h4>
                <p>One-on-one sessions to explore user needs and pain points.</p>
                <h4>3.	Focus Groups</h4>
                <p>Group discussions to understand collective user opinions.</p>
                <h4>4.	Usability Testing: </h4>
                <p>Observing users while they interact with a product.</p>
                <h4>5.	A/B Testing: </h4>
                <p>Comparing two versions of a product to determine which performs better.</p>
                <h4>6.	Heatmaps & Analytics: </h4>
                <p>Tracking user interactions to analyze behavior patterns.</p>
                <h4>7.	User Persona Development: </h4>
                <p>Creating fictional representations of target users based on research findings.</p>
                <h3><span>Conducting Effective User Research</span></h3>
                <ul>
                    <h4>1. Define Goals</h4>
                    <li>What do you want to learn?</li>
                    <li>Who are your target users?</li>
                    <h4>2. Choose the Right Methodology</h4>
                    <li>Pick research methods that best fit your objectives.</li>
                    <h4>3. Recruit Participants</h4>
                    <li>Select users that represent your target audience.</li>
                    <h4>4. Collect Data</h4>
                    <li>Conduct interviews, surveys, and usability tests.</li>
                    <h4>5. Analyze & Interpret Findings</h4>
                    <li>Look for patterns and insights in the collected data.</li>
                    <h4>6. Implement Findings</h4>
                    <li>Apply insights to product design, development, and marketing strategies.</li>
                </ul>
                <h3><span>Tools for User Research</span></h3>
                <ul>
                  <li>Google Analytics – Website traffic and user behavior analysis.</li>
                  <li>Hotjar – Heatmaps and session recordings.</li>
                  <li>SurveyMonkey – Online surveys.</li>
                  <li>UserTesting – Remote usability testing.</li>
                  <li>Optimal Workshop – Information architecture testing.</li>
                </ul>
                <h3><span>Challenges in User Research & Solutions</span></h3>
                <h4>1.	Recruiting the Right Participants</h4>
                <p>Use screening surveys to ensure relevant participants.</p>
                <h4>2.	Bias in Data Collection</h4>
                <p>Avoid leading questions and use diverse participant groups.</p>
                <h4>3.	Interpreting Data Accurately</h4>
                <p>Use both qualitative and quantitative analysis to validate insights.</p>
                <h4>4.	Time and Budget Constraints</h4>
                <p>Start with low-cost methods like surveys and interviews before investing in advanced tools.</p>
                <h3><span>Conclusion</span></h3>
                <p>User Research & Analysis is an essential practice for creating user-centric products and experiences. By employing the right research methods and tools, businesses can better understand their audience, make informed decisions, and drive long-term success. Investing in user research not only improves product usability but also ensures that businesses remain competitive in an ever-evolving market.</p>
            </div>
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default UserResearchAnalysis;
